import { render, staticRenderFns } from "./a01.vue?vue&type=template&id=12c9369b&"
import script from "./a01.vue?vue&type=script&lang=js&"
export * from "./a01.vue?vue&type=script&lang=js&"
import style0 from "./a01.vue?vue&type=style&index=0&id=12c9369b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports